module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginBox"
  }, [(_vm.browser) ? _c('div', {
    staticClass: "login",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "loginBG"
  }, [_c('div', {
    staticClass: "loginContent"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "loginBox"
  }, [_c('img', {
    staticClass: "icon-login",
    attrs: {
      "src": require("../assets/img/login_logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("习习教师")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.userName),
      expression: "userName",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "text",
      "placeholder": "您的账号或手机号"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paddWord),
      expression: "paddWord",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "pwdInput",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.paddWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paddWord = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginTools"
  }, [_c('div', {
    class: {
      checkbox: true, checked: _vm.isChecked
    },
    on: {
      "click": _vm.rememberPassword
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })]), _vm._v("\n              记住密码\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "button loginBtn",
    attrs: {
      "type": "button",
      "value": "登录"
    },
    on: {
      "click": _vm.login,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyLogin($event)
      }
    }
  })])])]), _vm._v(" "), (_vm.isDownload) ? _c('a', {
    staticClass: "download",
    attrs: {
      "href": _vm.loadUrl
    }
  }, [_vm._v("下载客户端")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-469b3192","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 1195
// module chunks = 1